import { message, notification } from "antd";
import { MessageInstance } from "antd/es/message/interface";
import { NotificationInstance } from "antd/es/notification/interface";
import React, { createContext } from "react";

// eslint-disable-next-line react-refresh/only-export-components
export const NotiContext = createContext<
  (NotificationInstance & { message: MessageInstance }) | null
>(null);

export const NotificationProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const [api, contextHolder] = notification.useNotification();
  const [apiMessage, messageContextHolder] = message.useMessage();
  return (
    <NotiContext.Provider value={{ ...api, message: apiMessage }}>
      {contextHolder}
      {messageContextHolder}
      {children}
    </NotiContext.Provider>
  );
};

export default NotificationProvider;
